// SPDX-License-Identifier: Apache-2.0
import DragManager from '../../components/treeview/tools/dragmanager';
import ApplicationLifeCycleManager from '../app/lifecyclemanager';
import AuthManager from '../auth/authmanager';
import PluginManager from '../auth/pluginmanager';
import ConfigManager from '../configuration/configmanager';
import ErrorManager from '../error/errormanager';
import I18nManager from '../i18n/i18nmanager';
import LayerManager from '../layers/layermanager';
import SnapManager from '../layers/snapmanager';
import LocalFileManager from '../localfile/localfilemanager';
import LogManager from '../logging/logmanager';
import OfflineManager from '../offline/offlinemanager';
import OgcApiFeaturesManager from '../ogcapi/ogcapifeaturesmanager';
import OnBoardingManager from '../onboarding/onboardingmanager';
import OrderingManager from '../ordering/orderingmanager';
import SessionManager from '../share/sessionmanager';
import ShareManager from '../share/sharemanager';
import StateSerializer from '../share/stateserializer';
import ComponentManager from '../state/componentManager';
import MapManager from '../state/mapManager';
import StateManager from '../state/statemanager';
import UserInteractionManager from '../state/userInteractionManager';
import CustomThemesManager from '../themes/customthemesmanager';
import ThemesHelper from '../themes/themeshelper';
import ThemesManager from '../themes/themesmanager';
import UserLayerManager from '../themes/userlayermanager';
import PermalinkManager from '../url/permalinkmanager';
import UrlManager from '../url/urlmanager';
import UserDataManager from '../userdata/userdatamanager';
import WfsManager from '../wfs/wfsmanager';
import WmsManager from '../wms/wmsmanager';
import WmtsManager from '../wmts/wmtsmanager';
import SelectionManager from '../selection/selectionmanager';
import IGirafeContext from './icontext';
import ThemeFavoritesManager from '../themes/themefavoritesmanager';
import SearchManager from '../search/searchmanager';
import FeedbackManager from '../feedback/feedbackmanager';
import ContextInitializationHelper from './contexthelper';

export default class GirafeContext implements IGirafeContext {
  public readonly userDataManager!: UserDataManager;
  public readonly configManager!: ConfigManager;
  public readonly stateManager!: StateManager;
  public readonly componentManager!: ComponentManager;
  public readonly userInteractionManager!: UserInteractionManager;
  public readonly i18nManager!: I18nManager;
  public readonly pluginManager!: PluginManager;
  public readonly themesManager!: ThemesManager;
  public readonly themesHelper!: ThemesHelper;
  public readonly permalinkManager!: PermalinkManager;
  public readonly dragManager!: DragManager;
  public readonly urlManager!: UrlManager;
  public readonly layerManager!: LayerManager;
  public readonly sessionManager!: SessionManager;
  public readonly stateSerializer!: StateSerializer;
  public readonly shareManager!: ShareManager;
  public readonly customThemesManager!: CustomThemesManager;
  public readonly errorManager!: ErrorManager;
  public readonly wfsManager!: WfsManager;
  public readonly authManager!: AuthManager;
  public readonly snapManager!: SnapManager;
  public readonly mapManager!: MapManager;
  public readonly logManager!: LogManager;
  public readonly offlineManager!: OfflineManager;
  public readonly applicationLifeCycleManager!: ApplicationLifeCycleManager;
  public readonly orderingManager!: OrderingManager;
  public readonly userLayerManager!: UserLayerManager;
  public readonly wmsManager!: WmsManager;
  public readonly wmtsManager!: WmtsManager;
  public readonly selectionManager!: SelectionManager;
  public readonly ogcApiFeaturesManager!: OgcApiFeaturesManager;
  public readonly localFileManager!: LocalFileManager;
  public readonly onBoardingManager!: OnBoardingManager;
  public readonly themeFavoritesManager!: ThemeFavoritesManager;
  public readonly searchManager!: SearchManager;
  public readonly feedbackManager!: FeedbackManager;

  private readonly contextHelper = new ContextInitializationHelper();

  public constructor() {
    this.contextHelper.constructContext(this);
  }

  public async initialize() {
    await this.contextHelper.initializeContext(this);
  }

  /** The context can contains hook methods that will be called after each manager initialization.
   * The hook method must be named with the property name + the "Hook" suffix.
   * The hook method must be async and will be awaited
   * For example, the methods themesManagerHook() will be called immediately after
   * the call of themesManager.initializeSingleton().
   * This allows specific initialization methods when defining custom contexts
   * (for example for the apiContext, the mockContext, or any customContext)
   */
}
